module.exports = __webpack_public_path__ + "c6d1d251ae0af6bd740772047a6d4134.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-30.png
// module id = 3088
// module chunks = 0